import type { ITableHeader } from "@/shared/components"

export const HEADERS: ITableHeader[][] = [
  [
    { label: "number" },
    { label: "company_name", style: { minWidth: 250 } },
    { label: "audit_type", style: { minWidth: 150 } },
    { label: "announcement_date", className: "whitespace-nowrap" },
    { label: "status", style: { minWidth: 150 } },
    { label: "sent-date" },
    { label: "actions", style: { minWidth: 132, textAlign: "center" } }
  ],
  []
]
